import { render, staticRenderFns } from "./ReplaceItem.vue?vue&type=template&id=96c39f02"
import script from "./ReplaceItem.vue?vue&type=script&lang=js"
export * from "./ReplaceItem.vue?vue&type=script&lang=js"
import style0 from "./ReplaceItem.vue?vue&type=style&index=0&id=96c39f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports